var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMyExamNonSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Icon_-_My_Exam_-_Non_Selected",
    width: 24,
    height: 24,
    "data-name": "Icon - My Exam - Non Selected",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:#fff;opacity:0}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__icon",
    d: "M0 0H24V24H0z",
    className: "prefix__cls-1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Icon_-_My_Exam_-_Non_Selected-2",
    "data-name": "Icon - My Exam - Non Selected",
    transform: "translate(2 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__frame",
    d: "M0 0H20V16H0z",
    className: "prefix__cls-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_3609",
    "data-name": "Group 3609"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6224",
    fill: "none",
    d: "M12 2v7.2a1.5 1.5 0 0 0 2.255 1.3L16 9.482l1.745 1.018A1.5 1.5 0 0 0 20 9.2V2a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2z",
    "data-name": "Path 6224",
    transform: "translate(-3)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Union_41",
    fill: "rgba(0,0,0,0)",
    stroke: "none",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-name": "Union 41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 15H3c-1.103 0-2-.897-2-2V2.796l.04-.197C1.228 1.673 2.053 1 3 1h3.167c.948 0 1.772.673 1.96 1.6l.163.8H17c1.103 0 2 .897 2 2V13c0 1.103-.897 2-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afafaf",
    d: "M17 14c.551 0 1-.448 1-1V5.4c0-.551-.449-1-1-1H9.107c-.95 0-1.77-.67-1.96-1.602C7.054 2.336 6.641 2 6.167 2H3c-.475 0-.887.336-.981.798L2 2.886V13c0 .552.449 1 1 1h14m0 2H3c-1.656 0-3-1.344-3-3V2.4h.06C.338 1.03 1.549 0 3 0h3.167c1.451 0 2.663 1.03 2.94 2.4H17c1.657 0 3 1.343 3 3V13c0 1.656-1.343 3-3 3z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Line_406",
    fill: "none",
    stroke: "#afafaf",
    strokeLinecap: "round",
    strokeWidth: "2px",
    d: "M0 0L11 0",
    "data-name": "Line 406",
    transform: "translate(4.5 11.6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMyExamNonSelected);
export default __webpack_public_path__ + "static/media/icon-my-exam-non-selected.984b6710ed388b39ab4754c2d3bb6c11.svg";
export { ForwardRef as ReactComponent };